// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'column-top-fill';

export const Component = () => (
  <path d='M0 .958s.096-.48.287-.67A.919.919 0 0 1 .958 0h22.606c.256 0 .48.096.67.287a.919.919 0 0 1 .288.67v22.606a.919.919 0 0 1-.287.67.919.919 0 0 1-.67.288H.957a.919.919 0 0 1-.67-.287.919.919 0 0 1-.288-.67V.957Zm7.855 22.605V8.813H.958v14.75h6.897Zm7.854 0V8.813H8.812v14.75h6.897Zm7.854-14.75h-6.897v14.75h6.897V8.813Z' />
);

export const viewBox = '0 0 25 25';
